<form-card
  [submitButton]="true"
  [backButton]="busOwnerStep && currentPrincipal"
  [submitDisabled]="disabled$ | async"
  [submitText]="currentPrincipal ? saveText.replace('Add', 'Update') : saveText"
  [submitButtonBg]="(isWhiteLabel$ | async) ? 'black' : 'tilled-primary'"
  [backButtonText]="'Delete'"
  [backButtonBorder]="(isWhiteLabel$ | async) ? 'black' : 'tilled-primary'"
  [titleText]="currentPrincipal ? title.replace('Add', 'Update') : title"
  [secondaryText]="secondaryText"
  [styles]="'w-[36.5rem] p-4'"
  [minWidth]=""
  [maxWidth]="'max-w-120'"
  (exitClick)="dialogRef.close()"
  (submitClick)="onContinueClicked($event)"
  (backClick)="removePrincipal()"
  [capitalizeTitle]="false"
  [capitalizeSubmitText]="false"
  [testIds]="{ exitButton: 'close-dialog', submitButton: 'save-button' }"
  class="*:pb-2"
  [merchantApp]="true"
>
  <div *ngIf="!isValid" class="pt-6">
    <merchant-app-alert
      data-test-id="addRepresentativeError"
      alertName="addRepresentativeReWarnAlertBox"
      title="Missing required information"
      description="This section has missing data that must be completed before submitting your application:"
      [subDescriptionArray]="missingFields"
      [hideEdit]="true"
    ></merchant-app-alert>
  </div>
  <form
    data-test-id="representatives-step"
    class="w-full"
    [formGroup]="representativesFormArray"
    *ngIf="busOwnerStep !== undefined"
  >
    <div *ngFor="let group of representativesFormArray.controls; let i = index" [formGroup]="group">
      <!-- Only show form of currentPrincipal -->
      <ng-container *ngIf="group?.get('id')?.value === currentPrincipal?.id">
        <!--Details-->
        <div class="mb-2 mt-6 flex flex-row items-center">
          <mat-divider class="w-full"></mat-divider>
          <tilled-label-l1
            [styles]="'font-[600]'"
            class="flex whitespace-nowrap px-2 text-lg leading-normal tracking-normal"
          >
            Personal Details</tilled-label-l1
          >
          <mat-divider class="w-full"></mat-divider>
        </div>
        <div [class]="busOwnerStep ? '-mb-3' : ''">
          <div class="mb-3 flex flex-col">
            <div class="flex w-full flex-col">
              <tilled-input
                data-test-id="reps-first-name"
                class="w-full"
                name="firstName"
                label="First name"
                placeholder="Enter first name"
                tilledLabel="true"
                [errors]="group.get('firstName').errors?.['required'] && group.get('firstName').touched"
                errorMessage="First Name is Required."
              ></tilled-input>
              <tilled-input
                data-test-id="reps-last-name"
                class="w-full"
                name="lastName"
                label="Last name"
                placeholder="Enter last name"
                tilledLabel="true"
                [errors]="group.get('lastName').errors?.['required'] && group.get('lastName').touched"
                errorMessage="Last Name is Required."
              ></tilled-input>
            </div>
            <mat-hint
              *ngIf="
                !(
                  (group.get('firstName').errors && group.get('firstName').touched) ||
                  (group.get('lastName').errors && group.get('lastName').touched)
                )
              "
              id="field-hint"
              class="ml-px flex pt-1 text-sm"
            >
              {{ busOwnerStep ? "Enter the owner's name" : 'Enter your name' }} exactly as it is recorded with
              government agencies (i.e. IRS).
            </mat-hint>
          </div>
          <div class="col-span-1 flex flex-col">
            <div class="w-full pb-2.5">
              <tilled-label-l1 secondary="true" class="pt-8">Job title</tilled-label-l1>
            </div>
            <tilled-select
              [multiple]="false"
              [options]="jobTitleMap"
              [placeholder]="'Select job title'"
              [controlName]="group.get('jobTitle')"
              data-test-id="reps-job-title"
              [classOverride]="'w-full mb-4'"
              [hint]="
                'If you don\'t see ' +
                (busOwnerStep ? 'their' : 'your') +
                ' exact job title, select the one which most closely matches ' +
                (busOwnerStep ? 'their' : 'your') +
                ' role and responsibilities.'
              "
              [errors]="group.get('jobTitle').errors?.['required'] && group.get('jobTitle').touched"
              errorMessage="Job title is Required."
            ></tilled-select>
          </div>
          <div class="pt-2" *ngIf="!hideOwnershipQuestion">
            <div *ngIf="!busOwnerStep" class="col-span-1 flex flex-col" [ngClass]="forConsole ? 'sm:grid-cols-2' : ''">
              <mat-checkbox
                data-test-id="reps-more-than-25"
                [color]="'primary'"
                (change)="onOwnsMoreThan25Percent(!ownsMoreThan25Percent)"
                class="-ml-2.5 text-white"
                [checked]="ownsMoreThan25Percent"
              >
                <tilled-paragraph-p4 [bold]="true" class="-ml-1.5 flex">
                  This individual owns 25% or more of this business.
                </tilled-paragraph-p4>
              </mat-checkbox>
            </div>
            <tilled-input
              *ngIf="ownsMoreThan25Percent || busOwnerStep"
              data-test-id="reps-ownership-percentage"
              class="-mt-3 flex flex-col"
              name="percentageShareholding"
              label="Ownership percent"
              tilledLabel="true"
              placeholder="Enter %"
              [showPercent]="true"
              minValue="0"
              maxValue="100"
              mask="percent"
              [errors]="group.get('percentageShareholding').errors"
              [errorMessage]="
                group.get('percentageShareholding').errors && group.get('percentageShareholding').touched
                  ? group.get('percentageShareholding').errors?.['min']
                    ? 'Must be greater than' + group.get('percentageShareholding').errors?.['min']?.min + '%'
                    : group.get('percentageShareholding').errors?.['max']
                      ? 'Must not be greater than 100%'
                      : 'Ownership percentage value is required.'
                  : null
              "
              [hint]="
                hasNorthProvider
                  ? 'Owners with more than 25% ownership will be invited to digitally sign the merchant agreement via email'
                  : 'Enter the % amount of the business owned by this individual'
              "
            ></tilled-input>
          </div>
          <tilled-input
            data-test-id="reps-dob"
            name="dob"
            label="Date of Birth"
            placeholder="MM/DD/YYYY"
            [sentenceCasePlaceholder]="false"
            tilledLabel="true"
            mask="M0/d0/0000"
            [dropMaskCharacters]="false"
            [leadZeroDateTime]="true"
            [errors]="group.controls.dob.errors && group.controls.dob.touched"
            [errorMessage]="
              group.controls.dob.errors?.['younger']
                ? 'Business owner must be older than 18.'
                : 'A valid date of birth is required.'
            "
          ></tilled-input>
          <tilled-input
            *ngIf="!hideSSN"
            data-test-id="reps-ssn"
            name="ssn"
            [mask]="!isCanadian ? '000-00-0000' : '000-000-000'"
            [placeholder]="
              representativesFormArray.value[i].ssn
                ? !isCanadian
                  ? 'Already submitted. Click if you need to update the SSN.'
                  : 'Already submitted. Click if you need to update the SIN.'
                : !isCanadian
                  ? 'Enter SSN'
                  : 'Enter SIN'
            "
            class="mb-5 flex flex-col"
            [label]="!isCanadian ? 'Social Security Number' : 'Social insurance number'"
            tilledLabel="true"
            [errors]="group.get('ssn')?.errors && group.get('ssn').touched"
            [errorMessage]="'A valid SSN is required'"
            [hint]="
              !isCanadian ? 'Per US regulations around anti-money laundering, we are required to collect the SSN.' : ''
            "
            [sentenceCaseTitle]="false"
            [sentenceCasePlaceholder]="false"
          ></tilled-input>
          <tilled-input
            data-test-id="reps-phone-number"
            class="flex w-full flex-col"
            name="phone"
            [prefix]="group.get('phone')?.value?.includes('+') ? '' : selectedPhoneCode"
            placeholder="(555) 000-0000"
            [mask]="group.get('phone')?.value?.includes('+') ? '+0 (000) 000-0000' : '(000) 000-0000'"
            label="PHONE NUMBER"
            tilledLabel="true"
            [errors]="group.get('phone')?.errors && group.get('phone').touched"
            errorMessage="Must be a valid phone number."
            [prefixMultiple]="false"
            [prefixOptions]="phoneCodeMap"
            [prefixControlName]="group.get('phoneCode')"
            [prefixPlaceholder]="'US'"
          ></tilled-input>
          <ng-container>
            <div class="grid w-full grid-cols-1 gap-x-6">
              <div class="col-span-1 flex flex-col">
                <tilled-input
                  data-test-id="reps-controller-email"
                  class="w-full"
                  name="email"
                  placeholder="your@email.com"
                  [sentenceCasePlaceholder]="false"
                  label="Email address"
                  tilledLabel="true"
                  [toolTip]="
                    !busOwnerStep
                      ? 'This email address will be used to verify the user for the digital signing step.'
                      : ''
                  "
                  [errors]="group.get('email')?.errors && group.get('email').touched"
                  errorMessage="A valid email address is required."
                ></tilled-input>
              </div>
            </div>
          </ng-container>
          <!--Owner Current Residential Address-->
          <div class="mt-6 flex flex-row items-center">
            <mat-divider class="w-full"></mat-divider>
            <tilled-label-l1
              [styles]="'font-[600]'"
              class="flex whitespace-nowrap px-2 text-lg leading-normal tracking-normal"
            >
              Address</tilled-label-l1
            >
            <mat-divider class="w-full"></mat-divider>
          </div>
          <div>
            <div class="w-full pb-2.5 pt-4">
              <tilled-label-l1> Residential address </tilled-label-l1>
            </div>
            <app-autocomplete
              data-test-id="contact-current-street"
              class="w-full"
              name="currentStreet"
              [autocompleteAddress]="representativesFormArray.value[i].currentStreet"
              (setAddress)="setPrincipalAddress($event, i, 'current')"
              [hint]="
                group.get('currentStreet').errors && group.get('currentStreet').touched
                  ? null
                  : 'Enter the address where this business owner lives. P.O. boxes are not accepted.'
              "
            ></app-autocomplete>
            <mat-error
              class="flex pt-1.5 text-sm font-medium text-warn"
              *ngIf="group.get('currentStreet').errors && group.get('currentStreet').touched"
            >
              {{
                group.get('currentStreet').errors?.['required']
                  ? 'A residential address is required'
                  : 'P.O. boxes are not accepted.'
              }}
            </mat-error>
            <tilled-input
              [ngClass]="{
                'mt-2 flex flex-col': !(group.get('currentStreet').errors && group.get('currentStreet').touched)
              }"
              data-test-id="contact-current-street2"
              name="currentStreet2"
              label="Apt, Suite, etc. (Optional)"
              placeholder="Suite 1234"
              tilledLabel="true"
              [sentenceCaseTitle]="false"
            ></tilled-input>
            <div class="col-span-1 flex flex-col">
              <div class="w-full pb-2.5 pt-4">
                <tilled-label-l1 secondary="true" class="pt-8">State</tilled-label-l1>
              </div>
              <tilled-select
                [multiple]="false"
                [options]="stateCodeMap"
                [placeholder]="'Choose One'"
                [controlName]="group.get('currentState')"
                data-test-id="contact-current-state"
                groupName="MerchantAppBusinessContactForm"
                [classOverride]="'w-full'"
                [errors]="group.get('currentState').errors && group.get('currentState').touched"
                errorMessage="State is required."
              ></tilled-select>
            </div>
            <div class="col-span-1 flex flex-col">
              <tilled-input
                data-test-id="contact-current-city"
                name="currentCity"
                label="CITY"
                placeholder="Louisville"
                tilledLabel="true"
                [errors]="group.get('currentCity').errors && group.get('currentCity').touched"
                errorMessage="City is required."
              ></tilled-input>
            </div>
            <div class="col-span-1 flex flex-col">
              <tilled-input
                data-test-id="contact-current-zip"
                name="currentZip"
                label="Zip code"
                tilledLabel="true"
                placeholder="80205"
                maxLength="10"
                [errors]="group.get('currentZip').errors && group.get('currentZip').touched"
                errorMessage="Zip code is required."
              ></tilled-input>
            </div>
            <div *ngIf="isCanadian" class="col-span-1 flex flex-col">
              <tilled-input
                data-test-id="reps-years-at-current-address"
                name="yearsAtCurrentAddress"
                label="# OF YEARS AT THIS ADDRESS"
                tilledLabel="true"
                placeholder="Enter #"
                minValue="1"
                [errors]="group.get('yearsAtCurrentAddress').errors && group.get('yearsAtCurrentAddress').touched"
                errorMessage="Years at current address is required."
              ></tilled-input>
            </div>
          </div>
          <!--Owner Current Residential Address-->
          <div *ngIf="representativesFormArray.value[i].yearsAtCurrentAddress <= 3 && isCanadian">
            <div class="w-full pb-2.5 pt-4">
              <tilled-label-l1>Owner Previous Residential Address</tilled-label-l1>
            </div>
            <div>
              <app-autocomplete
                data-test-id="contact-previous-street"
                class="w-full"
                name="previousStreet"
                [autocompleteAddress]="representativesFormArray.value[i].previousStreet"
                (setAddress)="setPrincipalAddress($event, i, 'previous')"
                [errors]="group.get('previousStreet').errors && group.get('previousStreet').touched"
                [errorMessage]="
                  group.get('previousStreet').errors?.['required']
                    ? 'A residential address is required'
                    : 'P.O. boxes are not accepted.'
                "
              ></app-autocomplete>
            </div>
            <tilled-input
              data-test-id="contact-previous-street2"
              class="w-full"
              name="previousStreet2"
              label="STREET ADDRESS 2"
              placeholder="Suite / Apt / Unit (Optional)"
              tilledLabel="true"
            ></tilled-input>
            <div class="grid w-full grid-cols-1 gap-x-6">
              <div class="col-span-1 flex flex-col">
                <tilled-input
                  data-test-id="contact-previous-city"
                  name="previousCity"
                  label="CITY"
                  placeholder="Louisville"
                  tilledLabel="true"
                  [errors]="group.get('previousCity').errors && group.get('previousCity').touched"
                  errorMessage="City is required."
                ></tilled-input>
              </div>
              <div class="col-span-1 flex flex-col">
                <div class="w-full pb-2.5 pt-4">
                  <tilled-label-l1 secondary="true" class="pt-8">{{
                    isCanadian ? 'Province' : 'State'
                  }}</tilled-label-l1>
                </div>
                <tilled-select
                  [multiple]="false"
                  [options]="stateCodeMap"
                  [placeholder]="'Choose One'"
                  [controlName]="group.get('previousState')"
                  classOverride="fuse-mat-dense fuse-mat-no-subscript fuse-mat-rounded w-full"
                  data-test-id="contact-previous-state"
                  groupName="MerchantAppBusinessContactForm"
                  [errors]="group.get('previousState').errors && group.get('previousState').touched"
                  [errorMessage]="(isCanadian ? 'Province' : 'State') + ' is required.'"
                ></tilled-select>
              </div>
            </div>
            <div class="col-span-1 flex flex-col">
              <tilled-input
                data-test-id="contact-previous-zip"
                name="previousZip"
                [label]="isCanadian ? 'Postal Code' : 'Zip Code'"
                placeholder="80205"
                tilledLabel="true"
                maxLength="10"
                [errors]="group.get('previousZip').errors && group.get('previousZip').touched"
                [errorMessage]="(isCanadian ? 'Postal Code' : 'Zip Code') + ' is required.'"
              ></tilled-input>
            </div>
            <div class="col-span-1 flex flex-col">
              <tilled-input
                data-test-id="reps-years-at-previous-address"
                name="yearsAtPreviousAddress"
                label="# OF YEARS AT THIS ADDRESS"
                tilledLabel="true"
                placeholder="Enter #"
                minValue="1"
                [errors]="group.get('yearsAtPreviousAddress').errors && group.get('yearsAtPreviousAddress').touched"
                errorMessage="Years at previous address is required."
              ></tilled-input>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </form>
</form-card>
